<template>
    <div class="parcours-all">
      <loader></loader>
      <div class="page-title-container">
          <h1>Parcours</h1>
      </div>

      <scroll-progress-bar></scroll-progress-bar>

      <div class="row scroll row--all">
          <div class="col-md-11 pull-right">
            <div class="vertical-list-container">
              <div class="vertical-list-wrapper">
                <div class="inner-links">
                  <router-link :to="{ name: 'home' }">
                    <span class="dash"></span>
                    Retour à l’accueil
                  </router-link>
                </div>

                <div class="page-subtitle-container">
                  <span class="dash"></span>
                  <h2>Parcours de lecture</h2>
                </div>

                <h3 v-for="parcours in parcoursAll">
                  <router-link :to="{ name: 'parcoursIndex', params: { parcoursId: parcours.id_keyword } }">
                    <span class="bg"></span>{{ parcours.versions[0].title }} <sup>{{ parcours.entities.length | romanize }}</sup>
                  </router-link>
                  </h3>
<!--
                <ul>
                  <li v-for="(epigram, index) in parcours.entities"
                      v-track-by="index">
                    <router-link :to="{ name: 'parcoursSingle', params: { parcoursId: parcours.id_keyword, epigramIndex: index + 1 }}">Épigramme {{ index + 1 }}</router-link>
                  </li>
                </ul>
-->
              </div>
            </div>
          </div>
      </div>
  </div>
</template>

<script>
import BackBtn from './partials/BackBtn'
import ScrollProgressBar from './partials/ProgressBar'
import Loader from './partials/Loader'

import $ from 'jquery'

export default {
  components: {
    BackBtn,
    ScrollProgressBar,
    Loader
  },
  name: 'ParcoursAll',
  data () {
    return {
      parcoursAll: {}
    }
  },
  created: function () {
    this.$nextTick(function () {
      // ensure elements are in-document
      // immediately show loader
      $('.loader').fadeIn()
    })
    this.getParcoursData()
  },
  methods: {
    getParcoursData: function () {
      var self = this
      self.$http.get(global.api + 'keywords?category=' + global.parcoursKeywordId).then(function (response) {
        var parcoursAllData = JSON.parse(response.bodyText)

        parcoursAllData.forEach(function (parcours, i) {
          if (!parcours.versions || !parcours.versions.length) {
            parcours.versions.push({title: 'Sans titre'})
          }
        })

        // Sort Parcours by most epigrams first
        parcoursAllData.sort(function (a, b) {
          return a.entities.length < b.entities.length
        })

        self.$set(this, 'parcoursAll', parcoursAllData)
      }, function (err) {
        console.error('Error retrieving parcours', err)
      }).finally(function () {
        // Processing should be finished at this point
        // Fade the loader out
        $('.loader').fadeOut()
      })
    }
  }
}
</script>

<style lang="sass" scoped>
$hover: .5s all linear
$raleway: 'Raleway', Helvetica, Arial, sans-serif

.parcours-all
  width: 100%
  height: 100%
  display: flex
  flex-direction: column

</style>



// WEBPACK FOOTER //
// ParcoursAllComponent.vue?4580bc50